let partner = {}

export const setPartner = (p) => {
  partner = p || {}
}

export const getPartner = () => {
  return partner
}
